import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: {
    company: { plans: url },
  },
} = config

const getUrl = (plan) => url.replace(':idCompany', plan.companyId || null)

const addModule = (plan) => axios.get(getUrl(plan), { headers: getHeaders(true) })

const removeModule = (plan) => axios.get(getUrl(plan), { headers: getHeaders(true) })

export default { addModule, removeModule }
